// extracted by mini-css-extract-plugin
export default {"modal":"CannedResponsesModal_modal__B60lj","base":"CannedResponsesModal_base__BTbBd","label":"CannedResponsesModal_label__koCfb","-center":"CannedResponsesModal_-center__FjvNB"};